import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { CashDocumentPostingCashbookTxnComponent } from './cashbook-txn/cashbook-txn.component';
import { CashDocumentPostingJournalTxnComponent } from './journal-txn/journal-txn.component';
import { SessionStates } from '../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-util-cash-document-posting',
  templateUrl: './cash-document-posting.component.html',
  styleUrls: ['./cash-document-posting.component.css']
})
export class CashDocumentPostingComponent implements  OnInit, OnDestroy {

  protected subs = new SubSink();
  selectedIndex = 0;
  @Input() cashDoc$: Observable<any>;
  cashDoc;

  @ViewChild(MatTabGroup) tabs?: MatTabGroup;
  @ViewChild(CashDocumentPostingJournalTxnComponent, { static: false }) journalTxnComponent: CashDocumentPostingJournalTxnComponent;
  @ViewChild(CashDocumentPostingCashbookTxnComponent, { static: false }) cashbookTxnComponent: CashDocumentPostingCashbookTxnComponent;

  constructor(private readonly sessionStore: Store<SessionStates>) {
  }

  ngOnInit(){
    this.subs.sink = this.cashDoc$.subscribe(resolve => {
      this.cashDoc = resolve;
      console.log(' this.cashDoc', this.cashDoc)
      console.log(' this.journalTxnComponent', this.journalTxnComponent)
      if(this.journalTxnComponent){
        this.journalTxnComponent.totalCredit = 0;
        this.journalTxnComponent.totalDebit = 0;
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
